import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GuestRmaButtons from "@SupplyLand/Widgets/RequestRma/GuestRmaButtons";
import GuestRmaProductList from "@SupplyLand/Widgets/RequestRma/GuestRmaProductList";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    order: state.pages.orderStatus.order,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface GuestRmaStyles {
    container?: GridContainerProps;
    rmaProductListGridItem?: GridItemProps;
    rmaButtonsGridItem?: GridItemProps;
    noRmaLinesGridItem?: GridItemProps;
    noRmaLinesWrapper?: InjectableCss;
    noRmaLinesText?: TypographyProps;
    titleGridItem?: GridItemProps;
    titleText?: TypographyProps;
}

export const guestRmaStyles: GuestRmaStyles = {
    container: {
        gap: 0,
        css: css`
            display: none;
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            justify-content: space-between;
        `,
    },
    titleText: {
        variant: "h5",
        as: "h2",
        css: css`
            @media print {
                font-size: 15px;
                padding-top: 15px;
                margin-bottom: 5px;
            }
            padding-top: 30px;
            margin-bottom: 0.5rem;
        `,
    },
    rmaProductListGridItem: { width: 12 },
    rmaButtonsGridItem: { width: 12 },
    noRmaLinesGridItem: { width: 12 },
    noRmaLinesWrapper: {
        css: css`
            margin-bottom: 10px;
        `,
    },
};

const styles = guestRmaStyles;

const GuestRma: FC<Props> = ({ order }) => {
    if (!order || !order.orderLines) {
        return null;
    }

    return (
        <GridContainer {...styles.container} data-test-selector="guestRmaContainer">
            <GridItem {...styles.rmaProductListGridItem}>
                <GuestRmaProductList />
            </GridItem>
            <GridItem {...styles.rmaButtonsGridItem}>
                <GuestRmaButtons />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GuestRma),
    definition: {
        displayName: "Guest RMA",
        group: "Return Request (RMA)",
        allowedContexts: ["OrderStatusPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
